import { c as _c } from "react-compiler-runtime";
import { runAfterTransition, useResizeObserver } from "@react-aria/utils";
import * as React from "react";
import { Popover as AriaPopover, PopoverContext, useContextProps } from "react-aria-components";
import { size } from "../sizes.js";
import { popover } from "./Popover.css.js";
import { jsx as _jsx } from "react/jsx-runtime";
export const POPOVER_OFFSET = 8; // px

const BasePopover = (t0, incomingRef) => {
  const $ = _c(20);
  let children;
  let incomingProps;
  let t1;
  if ($[0] !== t0) {
    ({
      children,
      width: t1,
      ...incomingProps
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = incomingProps;
    $[3] = t1;
  } else {
    children = $[1];
    incomingProps = $[2];
    t1 = $[3];
  }
  const width = t1 === undefined ? "triggerRef" : t1;
  const [props, ref] = useContextProps(incomingProps, incomingRef, PopoverContext);
  const {
    triggerRef
  } = props;
  const [inputWidth, setInputWidth] = React.useState(0);
  let t2;
  if ($[4] !== triggerRef) {
    t2 = () => {
      if (triggerRef?.current) {
        const width_0 = triggerRef.current.getBoundingClientRect().width;
        setInputWidth(width_0);
      }
    };
    $[4] = triggerRef;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const onResize = t2;
  let t3;
  if ($[6] !== onResize || $[7] !== triggerRef) {
    t3 = {
      ref: triggerRef,
      onResize
    };
    $[6] = onResize;
    $[7] = triggerRef;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  useResizeObserver(t3);
  let t4;
  let t5;
  if ($[9] !== onResize) {
    t4 = () => {
      const timeout = setTimeout(() => {
        runAfterTransition(onResize);
      }, 100);
      return () => {
        clearTimeout(timeout);
      };
    };
    t5 = [onResize];
    $[9] = onResize;
    $[10] = t4;
    $[11] = t5;
  } else {
    t4 = $[10];
    t5 = $[11];
  }
  React.useEffect(t4, t5);
  const t6 = width === "triggerRef" ? inputWidth : size[width];
  let t7;
  if ($[12] !== t6) {
    t7 = {
      width: t6
    };
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== children || $[15] !== props || $[16] !== ref || $[17] !== t7 || $[18] !== triggerRef) {
    t8 = /*#__PURE__*/_jsx(AriaPopover, {
      ref: ref,
      triggerRef: triggerRef,
      placement: "bottom",
      offset: POPOVER_OFFSET,
      maxHeight: 322,
      ...props,
      style: t7,
      className: popover,
      children: children
    });
    $[14] = children;
    $[15] = props;
    $[16] = ref;
    $[17] = t7;
    $[18] = triggerRef;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  return t8;
};
export const Popover = /*#__PURE__*/React.forwardRef(BasePopover);
//# sourceMappingURL=Popover.js.map